import styled from 'styled-components'

export const FeatureListComponent = styled.div`
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    list-style: none;
    padding: 0;

    li {
      flex-basis: 100%;
      margin: 0 0 10px;
      padding-left: 0;
      text-indent: 0;
      display: flex;

      &::before {
        margin-top: 4px;
      }

      @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
        flex-basis: 50%;
        margin-bottom: 20px;
        padding-right: 30px;
      }
    }
  }

  .no-feature-hint {
    margin-bottom: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 30px;
    }
  }

  .feature-list-tooltip {
    margin-left: 10px;
  }

  // currently just required for storybook,
  // because global application styles are not working there...
  .tooltip-location-btn {
    margin-top: 15px;
    display: block;
  }
`
